import { useEffect, useState } from "react";
import AuthService from "../../../modules/Admin/services/AuthService";
import SidebarBrand from "../../components/SidebarBrand";
import AppShell from "../../layout/AppShell";
import { partnerMenuGroups } from "../../layout/sidebarMenuConfigs";

export default function PartnerSidebar({ children }) {
  const [agency, setAgency] = useState(null);
  const clientId = AuthService.getLoggedInClientId();

  useEffect(() => {
    async function load() {
      try {
        setAgency(await AuthService.getAgencyLogoAndNameByClientId(clientId));
      } catch {
        setAgency(null);
      }
    }
    if (clientId) load();
  }, [clientId]);

  return (
    <AppShell
      menuGroups={partnerMenuGroups}
      sidebarHeader={<SidebarBrand agency={agency} />}
    >
      {children}
    </AppShell>
  );
}
